import { Component, OnInit } from '@angular/core';
import { User } from '../../model/user';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Employee } from '../../model/employee';
import { Indication, IndicationStatus } from '../../model/indication';
import { ConfirmDeleteComponent } from '../partials/confirm-delete/confirm-delete.component';
import { MatDialog } from '@angular/material';
import { ConfirmCreateComponent } from '../partials/confirm-create/confirm-create.component';

declare var Materialize: any;

@Component({
  selector: 'app-indications',
  templateUrl: './indications.component.html',
  styleUrls: ['./indications.component.css'],
  providers: [DBService]
})
export class IndicationsComponent implements OnInit {
  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  displayList: string[];

  user: User;
  employee: Employee;

  companies: Company[];

  company: Company;

  isCustomer: boolean;

  indications: Indication[];

  loading: boolean;

  email: string;
  name: string;
  companyName: string;
  contactEmail: string;
  contactName: string;
  contactPhone: string;

  constructor( private authService: AuthenticationService, private dbService: DBService, public dialog: MatDialog) {
    this.loading = true;


    this.user = this.authService.getUser();
    this.displayList = [];
    this.initData();
   }

   private initData() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.companies = companies;

        this.loadUser();
      });
  }

  private loadUser() {
    this.dbService.getObject<Employee>(`employees/${this.user.uid}`)
      .then(employee => {
        this.employee = employee;
        this.isCustomer = this.employee.companyUID !== 'I-Ganhei';

        if (this.isCustomer) {
          this.company = this.companies.filter(c => c.uid == this.employee.companyUID)[0];
        }

        this.loadIndications();
      });
  }

  private loadIndications() {
    this.dbService.listWithUIDs<Indication>('indications')
    .then(indications => {
      this.indications = indications;

      if (this.isCustomer) {
        this.indications = this.indications.filter(i => i.companyUID === this.employee.companyUID);
      } else {
        this.indications.forEach(i => i['companyName'] = this.companies.filter(c => c.uid === i.companyUID)[0]);
      }

      this.loading = false;
    });
  }

  private indicate() {
    this.loading = true;

    const indication = new Indication();
    indication.companyUID = this.employee.companyUID;
    indication.date = Date.now();
    indication.email = this.email;
    indication.status = IndicationStatus.NEW;
    if (this.name) {
      indication.name = this.name;
    }
    if (this.contactName) {
      indication.contactName = this.contactName;
    }
    if (this.contactPhone) {
      indication.contactPhone = this.contactPhone;
    }
    if (this.contactEmail) {
      indication.contactEmail = this.contactEmail;
    }

    this.dbService.insertInList<Indication>('/indications', indication)
      .then(() => this.registerSuccess())
      .catch(error => console.log(error));
  }

  private registerSuccess() {
    this.email = '';

    Materialize.toast('Indicação realizada com sucesso', 2000);

    this.loadIndications();
  }

  openDeleteModal(indication: Indication) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: indication.email }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmDelete(indication.uid); }
    });
  }

  private confirmDelete(uid: string) {
    this.loading = true;
    this.dbService.remove('/indications', uid)
      .then(() => {
        Materialize.toast('Indicação cancelada com sucesso', 2000)
        this.loadIndications();
      })
      .catch(error => console.log(error));
  }

  openApprovalModal(indication: Indication) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: indication.email, action: 'Tem certeza que deseja confirmar a indicação ' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmApproval(indication.uid); }
    });
  }

  private confirmApproval(uid: string) {
    this.loading = true;
    this.dbService.update(`/indications/${uid}`, { status: IndicationStatus.APPROVED } )
      .then(() => {
        Materialize.toast('Indicação aprovada com sucesso', 2000);
        this.loadIndications();
      })
      .catch(error => console.log(error));
  }

  openNewModal() {
    const dialogRef = this.dialog.open(ConfirmCreateComponent, {
      height: 'auto',
      width: '700px',
      data: { }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.indicate(); }
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/indications/indications.component.ts